import React from 'react';
import './NotFound.css';

function NotFound() {
  return (
    <section className="notFound">
      <h2 className="notFound__title"> 404 - Page Not Found</h2>
      <a href="/">Please comeback to a safe page</a>
    </section>
  );
}
export default NotFound;
